import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form'

import Text from './fields/text';
import Date from './fields/date';
import Checkbox from './fields/checkbox';

import Textarea from './fields/textarea';
import rightChevron from '../../assets/svg/right-chevron.svg';
import Isvg from 'react-inlinesvg';
import Link from '../../components/link';


import {
    Container,
    Row,
    Col,
} from 'reactstrap';

const required = value => value ? undefined : "Required"

const renderTextField = ({
    input,
    label,
    placeholder,
    meta: { touched, error },
    type,
    disabled
}) => (

        <Text
            placeholder={placeholder}
            errorText={touched && error}
            label={label}
            error={touched && error}
            type={type}
            disabled={disabled}
            {...input}
        />
    )
const renderCheckboxField = ({
    input,
    label,
    placeholder,
    meta: { touched, error },
    type
}) => (

        <Checkbox
            placeholder={placeholder}
            errorText={touched && error}
            label={label}
            error={touched && error}
            type={type}
            {...input}
        />
    )
const renderDateField = ({
    input,
    placeholder,
    label,
    type,
    meta: { touched, error },
}) => (
        <Date
            placeholder={placeholder}
            label={label}
            errorText={touched && error}
            type={type}
            error={touched && error}
            {...input}
        />
    )

const renderTextareaField = ({
    input,
    placeholder,
    label,
    meta: { touched, error },
}) => (

        <Textarea
            placeholder={placeholder}
            label={label}
            errorText={touched && error}
            error={touched && error}
            {...input}
        />
    )


class form extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }



    render() {

        const { handleSubmit, pristine, reset, submitting } = this.props;
        console.log(pristine, submitting);

        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Col lg="12">
                        <div className="field-wrap">
                            <Field
                                name="name"
                                component={renderTextField}
                                label={"Ime i prezime".translate(this.props.lang)}
                                placeholder={"Enter name".translate(this.props.lang)}
                                validate={[required]}
                            ></Field>
                        </div>
                    </Col>
                    
                    <Col lg="12">
                        <div className="field-wrap">
                            <Field
                                name="date"
                                component={renderDateField}
                                label={"Datum rodjenja".translate(this.props.lang)}
                                validate={[required]}
                            ></Field>
                        </div>
                    </Col>
                  
                    <Col lg="12">
                        <div className="field-wrap">
                            <Field
                                name="username"
                                component={renderTextField}
                                label={"Username".translate(this.props.lang)}
                                placeholder={"Enter username".translate(this.props.lang)}
                                validate={[required]}
                            ></Field>
                        </div>
                    </Col>
                    
                    <Col lg="12">

                        <div className="field-wrap">
                            <Field
                                name="email"
                                component={renderTextField}
                                label={"Email".translate(this.props.lang)}
                                placeholder={"Enter email".translate(this.props.lang)}
                                validate={[required]}
                                disabled
                            ></Field>
                        </div>
                    </Col>
                    <Col lg="12">

                        <div className="field-wrap">
                            <Field
                                name="sex"
                                component={renderCheckboxField}
                                label={"Pol".translate(this.props.lang)}
                                // placeholder={"Enter email".translate(this.props.lang)}
                                validate={[required]}
                            ></Field>
                        </div>
                    </Col>


                    <Col lg="12" className="edit-profile-btn-wrap">
                        
                            <button className="edit-profile-button">{'SAČUVAJ IZMENE'.translate(this.props.lang)}</button>

                    </Col>

                </Row>


            </form>

        )
    }
}

export default reduxForm({
    form: 'form'  // a unique identifier for this form
})(form)
